const mainPagetabs = document.querySelectorAll('.main-page-tab');

mainPagetabs.forEach( tab => {
  tab.addEventListener('click', event => {
    event.preventDefault();
    
    if (!tab.classList.contains('active')) {
      const activeElement = tab.closest('.main-page-tabs').querySelector('.main-page-tab.active');
      if (activeElement) activeElement.classList.remove('active');

      tab.classList.add('active');
      tab.closest('.main-page-tabs').classList.add('page-loading');
      document.querySelectorAll('#MainContent .shopify-section').forEach( section => {
        if (!section.classList.contains('section-main-page-tabs')) {
          section.remove();
        }
      });

      const loaderHTML = `<div class="page-loader loader-i1"><span class="line line-1"></span><span class="line line-2"></span><span class="line line-3"></span><span class="line line-4"></span><span class="line line-5"></span><span class="line line-6"></span><span class="line line-7"></span><span class="line line-8"></span><span class="line line-9"></span></div>`;
      document.getElementById('MainContent').insertAdjacentHTML('beforeend', loaderHTML);

      fetch(tab.href)
      .then( response => response.text())
      .then( html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');


        setTimeout( () => {
          if (document.querySelector('.page-loader')) document.querySelector('.page-loader').remove();
          tab.closest('.main-page-tabs').classList.remove('page-loading');
        }, 100);

        doc.querySelectorAll('#MainContent .shopify-section').forEach( section => {
          section.classList.add('hidden');
          
          if (!section.classList.contains('section-main-page-tabs')) {
            document.getElementById('MainContent').insertAdjacentHTML('beforeend', section.outerHTML);

            setTimeout( () => {
              document.getElementById(section.id).classList.remove('hidden');
            }, 100);
          }
        });
      });
    }
  });
});